/**
 * Veeroute.Lastmile
 * Veeroute Lastmile API
 *
 * The version of the OpenAPI document: 3.15.183137
 * Contact: support@veeroute.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Possibility of a object rotation.
 */
export enum RotationTypeLastmile {
    ALL = 'ALL',
    YAW = 'YAW',
    PITCH = 'PITCH',
    ROLL = 'ROLL'
};

